import StateContext from './StateContext';
import { DefaultClaim } from '../utils/AccountsAPI';

export const DefaultClaimsContext = StateContext<DefaultClaim[]>([[], () => {}]);

export default DefaultClaimsContext;
